<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>

<div class="modal-body">
  <div class="alert" [ngClass]="acceptedCount ? 'alert-success' : 'alert-warning'">
    <i class="fa" [ngClass]="acceptedCount ? 'fa-check' : 'fa-exclamation-triangle'"></i>
    {{ acceptedCount }} élément(s) ajouté(s), {{ rejected.length }} rejeté(s).
  </div>

  <table class="table table-striped table-condensed" *ngIf="rejected.length">
    <thead>
    <tr>
      <th>{{ valueLabel }}</th>
      <th>Raison du rejet</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of rejected">
      <td>{{ item.value }}</td>
      <td>{{ item.reason }}</td>
    </tr>
    </tbody>
  </table>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="modal.close()">Fermer</button>
</div>
